import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { B, Btn, Field, Input } from '../components/UI';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, isAdmin } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { data, error: err } = await signIn(email, password);
    setLoading(false);
    if (err) { setError('Invalid email or password. Please try again.'); return; }
    // redirect based on role — profile loads async so we check via data
    navigate('/');
  }

  return (
    <div style={{
      minHeight: '100vh', background: B.navy,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
      fontFamily: "'Barlow', sans-serif",
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div style={{ width: 52, height: 52, background: B.amber, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26 }}>🦅</div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 28, fontWeight: 800, color: '#fff', lineHeight: 1, letterSpacing: '.04em' }}>NIGHTHAWK</div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, color: B.amber, letterSpacing: '.12em' }}>ROOFING</div>
            </div>
          </div>
          <p style={{ color: '#94A3B8', fontSize: 14 }}>Project Management Portal</p>
        </div>

        {/* Card */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '2rem', boxShadow: '0 24px 64px rgba(0,0,0,.4)' }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4, fontFamily: "'Barlow Condensed', sans-serif", color: B.navy }}>Sign in to your account</h2>
          <p style={{ fontSize: 13, color: '#94A3B8', marginBottom: '1.5rem' }}>Enter your email and password to access your projects</p>

          <form onSubmit={handleSubmit}>
            <Field label="Email address" required>
              <Input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required />
            </Field>
            <Field label="Password" required>
              <Input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required />
            </Field>

            {error && (
              <div style={{ color: B.danger, fontSize: 12, marginBottom: 12, padding: '8px 12px', background: '#FEF2F2', borderRadius: 8, border: '1px solid #FECACA' }}>
                ⚠ {error}
              </div>
            )}

            <Btn type="submit" variant="dark" size="lg" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? 'Signing in…' : 'Sign in →'}
            </Btn>
          </form>

          <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#F8FAFC', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 12, color: '#64748B' }}>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>Need access?</div>
            Contact your Nighthawk Roofing project manager to receive your login credentials.
          </div>
        </div>
      </div>
    </div>
  );
}
